<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" class="filled" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-30">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style4 mg-b-10">
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Шинэ ажилтан</router-link></li>
              <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Тавтай морил</router-link></li>
              <li class="breadcrumb-item active tx-14" aria-current="page">Хөнгөлөлт, хангамж</li>
            </ol>
          </nav>


          <div class="row">
            <div v-for="(t, ti) in tasks" class="col-xxl-2 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div @click="showItem(t)" role="button" class="">
                <div class="overflow-hidden w-full rounded-20 mg-b-10 pos-relative ht-250"
                :style="`background-image: url(${t.secondAttachmentUrl}); background-size: cover; background-repeat: no-repeat`">
                  <div class="pos-absolute l-0 b-0 wd-100p tx-bold tx-16 pd-x-20 pd-y-15 tx-white text-center"
                  style="border-radius: 0 0 20px 20px; background: rgba(0,0,0,0.5); backdrop-filter: blur(7.2px);">
                    {{ t.task }}
                  </div>  
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>
    </div>

    </div>
    <b-modal v-model="task.mdl" centered hide-footer size="lg" :title="task.obj.task">
      <div v-if="task.obj.defaultAttachmentId==null || task.obj.defaultAttachmentId==0" v-html="task.obj.taskDesc"></div>
      <div v-else>
        <div v-if="getFileMode(task.obj)=='video'">
          <video width="100%" controls controlslist="nodownload" autoplay>
            <source
              :src="task.obj.defaultAttachmentUrl"
              type="video/mp4"
            />
            Your browser does not support HTML5 video.
          </video>
        </div>
        <div v-else-if="getFileMode(task.obj)=='image'">
          <img :src="task.obj.defaultAttachmentUrl" />
        </div>
        <div v-else>...</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";
import { getFileMode } from "@/libs/tools";


import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import Masonry from "masonry-layout"

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      mdl:{
        show: false
      },
      curInd: 0,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      tasks: [],
      task:{
        mdl: false,
        rdy: false,
        obj:{}
      },
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    getFileMode(task){
      return getFileMode(task.defaultAttachmentExt);
    },
    showItem(task){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/TaskInheritedDetail" },
        params: { id: task.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          console.log('sdf', res.data.task);
          this.task.obj= res.data.task;
          this.task.rdy= true;
          this.task.mdl= true;
        }
      });
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
      let _pid = 0;
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        (x) => x.objectTypeId == 612
      );
      if (proj.length) {
        _pid = proj[0].id;
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            projectId: _pid,
            skip: 0,
            size: 200,
            model: {
              isPublic: true
            },
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.tasks= res.data.tasks;
          }
        });
      }
    },
    
  },
};
</script>